export default "__VITE_ASSET__a1e0e8e2__"